<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createEmployee') }}</h1>
      <div class="form-container">
        <EmployeeForm @save="save"></EmployeeForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import EmployeeForm from "@/components/EmployeeForm"

  export default {
    components: {
      EmployeeForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/create', {actionType: 'employees', payload}).then(() =>
          this.$router.push({ name: 'employees'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'employees'})
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'employees', path: 'employees'},
          {name: 'createEmployee'}
        ]
      }
    }
  }
</script>